import React, { cloneElement } from 'react';
import {
  Datagrid,
  ExportButton,
  Filter,
  List,
  sanitizeListRestProps,
  Show,
  ShowButton,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
} from 'react-admin';

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { currentSort, resource, displayedFilters, filterValues, basePath, showFilter, total } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ExportButton disabled={total === 0} resource={resource} sort={currentSort} filterValues={filterValues} maxResults={10000} />
    </TopToolbar>
  );
};

const ListFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Room ID" source="roomId||$eq" alwaysOn />
    <TextInput label="User ID" source="userId||$eq" alwaysOn />
    <TextInput label="User Email" source="user.email||$contL" alwaysOn />
  </Filter>
);

export const SwicaList = (props: any) => (
  <List {...props} filters={<ListFilter />} actions={<ListActions />} title="Swica Second Chance">
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="roomId" />
      <TextField source="userId" />
      <TextField source="user.email" />
      <TextField source="createdAt" />
      <ShowButton />
    </Datagrid>
  </List>
);

export const SwicaShow = (props: any) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Swica Second Chance">
        <TextField source="id" />
        <TextField source="userId" />
        <TextField source="roomId" />
        <TextField source="user.email" />
        <TextField source="user.firstname" />
        <TextField source="user.lastname" />
        <TextField source="user.gender" />
        <TextField source="user.yearOfBirth" />
        <TextField source="user.phone" />
        <TextField source="user.street" />
        <TextField source="user.zip" />
        <TextField source="user.city" />
        <TextField source="user.country" />
        <TextField source="createdAt" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
